import { update } from 'jdenticon';
import { useEffect, useRef } from 'react';

export default function Avatar({
    value = 'default',
    size = '44',
}: {
    value?: string;
    size?: string;
}) {
    const icon = useRef<SVGSVGElement>(null);

    useEffect(() => {
        if (icon.current) update(icon.current, value);
    }, [value]);

    return (
        <div className="shrink-0 w-auto h-auto rounded-md bg-page border-[0.5px] border-line overflow-hidden">
            <svg data-jdenticon-value={value} height={size} ref={icon} width={size} />
        </div>
    );
}
